import axios from 'axios'
import authentication from 'services/authentication.js'
import devMode from '@/devMode.js'
import logScope from 'log-scope'
import download from 'services/download.js'
import dataLog from 'services/dataLog.js'
import urlConfig from 'services/urlConfig.js'
import store from '@/store/store.js'

const log = logScope('api')

const api = {
  url: urlConfig.rideqMain,
  instance: axios.create({
    baseURL: urlConfig.rideqMain,
    headers: {}
  }),
  post: (route, body) => api.instance.post(route, body),
  get: (route, body) => api.instance.get(route, body)
}

api.applyAuth = () => {
  return authentication.getToken()
    .then(token => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      return Promise.resolve()
    })
}

api.signup = email => {
  const timestamp = (new Date()).valueOf()
  const abTestCode = store.getters.abTestCode
  let route = `newSubscriber?email=${email}&timestamp=${timestamp}`

  if (abTestCode) {
    route += `&abTestCode=${abTestCode}`
  }

  dataLog.latest({
    status: 'success',
    abTestCode: abTestCode,
    message: 'New subscriber'
  })

  return api.post(route)
}

api.getCouponPrice = code => {
  let body = { code }
  return api.post('getCouponPrice', body)
}

api.purchase = (purchaseInformation) => {
  const abTestCode = store.getters.abTestCode
  let body = { ...purchaseInformation }

  if (abTestCode) {
    body.abTestCode = abTestCode
  }

  return api.post('purchase', body)
}

api.clearTestPurchases = () => {
  return api.post('clearTestPurchases')
}

api.clearTestSubscriptions = () => {
  return api.post('clearTestSubscriptions')
}

api.headQSettings = profile => {
  return api.get(`headQSettings?profile=${profile}`)
}

api.headQFirmware = async profile => {
  const res = await api.get(`headQFirmware?profile=${profile}`)
  const downloadUrl = res.data.downloadUrl

  download(downloadUrl)

  log.success('Firmware downloaded from: ', downloadUrl)

  return res
}

api.updateSubscriberReport = async () => {
  return api.post(`subscriberReport`)
}

if (devMode.globalShortcuts === true) {
  log.danger('Global shortcut')
  window.api = api
}

export default api
